import { inject } from '@angular/core';
import { CanActivateFn, CanActivateChildFn, Router, type MaybeAsync, type GuardResult } from '@angular/router';
import { AuthService } from '@infra-adapters/services/auth.service';

const checkFirstLogin = (): GuardResult => {
  const authService = inject(AuthService);
  const router = inject(Router);
  const session = authService.UserSessionData();
  if (session?.must_change_password) {
    return router.createUrlTree(['/cambiar-contrasena-inicial']);
  }
  return true;
};

export const FirstLoginGuard: CanActivateFn = (): MaybeAsync<GuardResult> => checkFirstLogin();
export const FirstLoginChildGuard: CanActivateChildFn = (): MaybeAsync<GuardResult> => checkFirstLogin();
